import React from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button, Table} from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Breadcrumb from 'components/layout/Breadcrumb';
import _, {} from "lodash";
import Loader from 'components/layout/Loader';
import SimplePrompt from 'components/layout/SimplePrompt';
import may from "../../../security";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import ServiceTypesNew from "../../../components/modals/ServiceTypesNew";
import ServiceTypesEdit from "../../../components/modals/ServiceTypesEdit";
import {getServiceTypesR, deleteServiceTypeR} from "../../../actions/ServiceTypesActions";
import FormSwitchery from "../../../components/forms/FormSwitchery";


class ServiceTypes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showEdit:false,
      serviceTypeId: "",
    };
  }

  componentDidMount = () => {
    const {getServiceTypesR} = this.props;
    getServiceTypesR();

  }

  componentDidUpdate = (prevProps) => {

  }

  openAddProvisionService = () => {
    this.setState({ showNew: true });
  }

  closeAddProvisionService = () => {
    this.setState({ showNew: false });
  };

  openEditProvisionService = (serviceTypeId) => {
   this.setState({serviceTypeId: serviceTypeId}, () => {
    this.setState({ showEdit: true });
   })
  }

  deleteProvisionService = (id) => {
    this.props.deleteServiceTypeR(id)
  }

  closeEditProvisionService= () => {
    this.setState({ showEdit: false });
  };


  translateDescription = (i) => {
    const index = _.findIndex(this.props.serviceTypesR[i].description, descriptionR => descriptionR.lang === this.props.appIntl.locale);
    return this.props.serviceTypesR[i].description[index].description //or name
  }

  translateTitle = (i) => {
    const index = _.findIndex(this.props.serviceTypesR[i].title, title => title.lang === this.props.appIntl.locale);
    return this.props.serviceTypesR[i].title[index].name
  }

  render() {
    const {
      intl: {messages},
      appIntl,
    } = this.props;
    const {showNew, showEdit, serviceTypeId} = this.state;
    const columns = [ messages.provision_service_type, messages.provision_service_title, messages.provision_service_description_text, messages.provision_service_primary_rate, messages.provision_service_secondary_rate, messages.provision_service_type_status, messages.provision_actions];
    let tBody = [];

    //get serviceTypesR from api
    let serviceTypesR = this.props.serviceTypesR;//[{id: "123", title: "serviceTypeTitel", type: "onboarding", rate1: "10%", rate2: "5%", }]
    if (serviceTypesR && serviceTypesR.length > 0) {
    _.forEach(serviceTypesR, (serviceType, i) => {
      tBody.push(
        <tr key={i} class="clickable" onClick={() => this.openEditProvisionService(serviceType.id)}>
          <td class="v-align-middle">
            <span>{serviceType.name}</span>
          </td>
          <td className="v-align-middle">
            <span>{this.translateTitle(i)}</span>
          </td>
          <td className="v-align-middle">
            <span>{this.translateDescription(i)}</span>
          </td>
          <td className="v-align-middle">
            <span>{serviceType.primary_rate}%</span>
          </td>
          <td className="v-align-middle">
            <span>{serviceType.secondary_rate}%</span>
          </td>
          <td className="v-align-middle">
            <FormSwitchery
              name="status"
              label=""
              value
              checked={!!serviceType.is_active}
              onChange=""
              disabled="disabled"
            />
          </td>
          <td class="v-align-middle text-right">
            {may('ROLE_ADMIN', this.props.user.roles) && (
              <>
                <SimplePrompt
                  onSuccess={e => this.deleteProvisionService(serviceType.id)}
                />
                <Button onClick={() => this.openEditProvisionService(serviceType.id)} bsStyle="warning"
                        className="pull-right m-l-10 m-t-10" title="create_service_type">
                  <span className="hidden-xs">{messages.edit_provision_type}</span>
                </Button>
              </>
            )}
          </td>
        </tr>
      );
    });
  }
    return (
      <div>
        <div class="serviceTypesHeader" style={{backgroundColor:"#FFFFFF"}}>
          <div className="padding-25 sm-padding-10" style={{display:"inline-block", width:"70%"}}>
            <Breadcrumb
              crumbs={[
                { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
                { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
                { link: null, name: messages.provision_service },
              ]}
              className="p-t-0"
            />
            <h4 className="bold"><i className="fad fa-concierge-bell"></i><span> {this.props.intl.messages.provision_service}</span></h4>
          </div>
          <Button onClick={()=>this.openAddProvisionService()} bsStyle="primary" className="btn-rounded" title="add_provision_service">
            <i className="fal fa-plus m-r-10 sm-m-r-0" /> <span className="hidden-xs">{messages.add_provision_type}</span>
          </Button>
        </div>


        <div className="padding-25 sm-padding-10">
          {this.props.pending ? <Loader/> :
            <Table responsive hover>
              <thead>
              <tr>
                {columns.map((column, i) => {
                  return (
                    <th key={i} className={column === messages.actions ? 'text-right' : ''}>
                      {column}
                    </th>
                  );
                })}
              </tr>
              </thead>
              <ReactCSSTransitionGroup
                transitionName="tablerows"
                transitionEnterTimeout={500}
                transitionLeaveTimeout={1}
                component="tbody"
              >
                {tBody}
              </ReactCSSTransitionGroup>
            </Table>
          }
        </div>
        <div id="serviceTypes-new">
          <ServiceTypesNew show={showNew} close={this.closeAddProvisionService} />
        </div>

        <div id="serviceTypes-edit">
          <ServiceTypesEdit show={showEdit} close={this.closeEditProvisionService} serviceTypeId={serviceTypeId}/>
        </div>


      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    client: state.selectedClient.company,
    serviceTypesR: state.provisionServiceTypes.serviceTypesR,
    pending: state.provisionServiceTypes.pending,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getServiceTypesR: () => {
      dispatch(getServiceTypesR());
    },
    deleteServiceTypeR: (id) => {
      dispatch(deleteServiceTypeR(id));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ServiceTypes)
  )
);
